(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-cart-header"] && !Shopify.designMode) return;
  try {
    
  /* Hlavicka kosiku zije ve vlastni sekci, takze ji Horizon pri zmene
     kosiku neprekresli – pocet u nadpisu i castka do dopravy zdarma by
     zustaly viset na puvodni hodnote. Po udalosti o zmene radku si sekci
     doptame znovu a obsah vymenime; cisla tak porad formatuje Liquid
     podle nastaveni obchodu. */
  class TbCartLive extends HTMLElement {
    connectedCallback() {
      this.onUpdate = (event) => {
        const p = event && event.promise;
        if (p && typeof p.then === 'function') p.then(() => this.refresh(), () => this.refresh());
        else this.refresh();
      };
      document.addEventListener('shopify:cart:lines-update', this.onUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:cart:lines-update', this.onUpdate);
    }

    refresh() {
      if (this.busy) return;
      this.busy = true;
      fetch(location.pathname + '?section_id=' + this.dataset.sectionId)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('tb-cart-live');
          /* Kdyz odpoved neprisla cela, radeji necham viset stary stav nez
             abych hlavicku vyprazdnil. */
          if (fresh) this.innerHTML = fresh.innerHTML;
        })
        .catch(() => {})
        .finally(() => { this.busy = false; });
    }
  }

  if (!customElements.get('tb-cart-live')) customElements.define('tb-cart-live', TbCartLive);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-collection"] && !Shopify.designMode) return;
  try {
    
  class TbCollectionFilter extends HTMLElement {
    connectedCallback() {
      const scope = this.closest('.tb-col') || document;
      this.grid = scope.querySelector('[data-grid]');
      if (!this.grid) return;

      this.cards = Array.from(this.grid.children);
      this.none = scope.querySelector('[data-none]');

      this.readOrigin();
      this.readParams();
      this.addEventListener('change', () => {
        this.apply();
        this.writeParams();
      });
      // Vzdy – chip muze byt predvybrany z tagove adresy. Bez filtru projde vse.
      this.apply();
    }

    /* Klíč pro porovnání zemí: malá písmena, bez diakritiky, spojovník = mezera –
       stejně jako v tb-globe.js, aby odkaz z legendy vždy našel kartu. */
    fold(name) {
      return name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
    }

    /* ?zeme=Etiopie z legendy zeměkoule: karta nese data-origin. */
    readOrigin() {
      const raw = new URLSearchParams(location.search).get('zeme');
      if (!raw) return;
      this.origin = this.fold(raw);
      if (!this.origin) return;

      const url = new URL(location.href);
      url.searchParams.delete('zeme');

      const row = document.createElement('div');
      row.className = 'tb-col__group tb-col__group--origin';
      row.innerHTML =
        '<span class="tb-col__group-label-text"></span>' +
        '<div class="tb-col__filters"><a class="tb-col__sub is-active"></a></div>';
      row.querySelector('.tb-col__group-label-text').textContent = this.dataset.originLabel || 'Země';
      const a = row.querySelector('a');
      a.href = url.pathname + url.search;
      a.setAttribute('aria-label', (this.dataset.originClear || 'Zrušit filtr') + ': ' + raw.trim());
      a.append(raw.trim(), ' ');
      const x = document.createElement('span');
      x.className = 'tb-col__sub-x';
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '×';
      a.append(x);
      this.prepend(row);
    }

    /* Vyber filtru v adrese (?priprava=espresso&chut=cokoladova): odkaz jde
       sdilet a po navratu zpet z detailu produktu se vyber obnovi. */
    static PARAMS = { brew: 'priprava', taste: 'chut' };

    readParams() {
      const params = new URLSearchParams(location.search);
      Object.entries(TbCollectionFilter.PARAMS).forEach(([group, key]) => {
        const value = (params.get(key) || '').toLowerCase().trim();
        if (!value) return;
        const input = Array.from(this.querySelectorAll(`input[name="tb-col-${group}"]`)).find((i) => i.value.toLowerCase() === value);
        if (input) input.checked = true;
      });
    }

    writeParams() {
      const url = new URL(location.href);
      Object.entries(TbCollectionFilter.PARAMS).forEach(([group, key]) => {
        const checked = this.querySelector(`input[name="tb-col-${group}"]:checked`);
        if (checked && checked.value) url.searchParams.set(key, checked.value);
        else url.searchParams.delete(key);
      });
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }

    apply() {
      const tags = Array.from(this.querySelectorAll('input[type="radio"]:checked'))
        .map((i) => i.value.toLowerCase())
        .filter(Boolean);

      let shown = 0;
      this.cards.forEach((card) => {
        const have = (card.dataset.tags || '').split(/\s+/);
        let match = tags.every((t) => have.includes(t));
        if (match && this.origin) match = this.fold(card.dataset.origin || '') === this.origin;
        card.hidden = !match;
        if (match) shown += 1;
      });

      if (this.none) this.none.hidden = shown > 0;
    }
  }

  if (!customElements.get('tb-collection-filter')) customElements.define('tb-collection-filter', TbCollectionFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-finder"] && !Shopify.designMode) return;
  try {
    
  class TbFinder extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.tb-finder__card'));
      this.inputs = Array.from(this.querySelectorAll('input[type="radio"][data-group]'));
      this.reason = this.querySelector('[data-reason]');
      this.results = parseInt(this.dataset.results, 10) || 2;
      this.emptyText = this.dataset.empty || '';
      this.fullMatchText = this.dataset.full || '';
      this.partialText = this.dataset.partial || '';
      this.noMatchText = this.dataset.nomatch || '';
      if (!this.cards.length) return;

      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"][data-group]')) this.recommend();
      });
      this.recommend();
    }

    /* Ukaze vybrane karty v danem poradi (presune je na zacatek). */
    show(chosen) {
      const parent = this.cards[0].parentNode;
      chosen.forEach((card) => parent.appendChild(card));
      this.cards.forEach((card) => { card.hidden = !chosen.includes(card); });
    }

    say(text) {
      if (!this.reason) return;
      this.reason.textContent = text;
      this.reason.hidden = !text;
    }

    tagsOf(card) {
      return (card.dataset.tags || '').split(/\s+/).filter(Boolean);
    }

    /* Tvrdou podminku (priprava) musi kava splnit. Volba bez tagu
       („Vše“) neomezuje nic. */
    hardPicks(exceptGroup) {
      return this.inputs
        .filter((i) => i.checked && i.hasAttribute('data-hard') && i.value && i.dataset.group !== exceptGroup)
        .map((i) => i.value.toLowerCase());
    }

    passes(card, required) {
      const tags = this.tagsOf(card);
      return required.every((t) => tags.includes(t));
    }

    /* Volba, se kterou by pri soucasnem tvrdem vyberu nic nezbylo, se
       vypne. Pro tvrdou skupinu se pocita bez ni same, aby slo prepnout
       treba z espressa na filtr. Vypnuta a zaskrtnuta volba se odskrtne. */
    updateAvailability() {
      this.inputs.forEach((input) => {
        const tag = input.value.toLowerCase();
        if (!tag) { input.disabled = false; return; }
        const required = this.hardPicks(input.hasAttribute('data-hard') ? input.dataset.group : null).concat(tag);
        const possible = this.cards.some((card) => this.passes(card, required));
        input.disabled = !possible;
        if (!possible && input.checked) input.checked = false;
      });
    }

    recommend() {
      this.updateAvailability();
      /* Novy los pri kazdem kliknuti: pri shode skore rozhoduje nahoda,
         aby stejny vyber neukazoval porad tytez kavy. */
      this.lottery = this.cards.map(() => Math.random());

      const required = this.hardPicks(null);
      const soft = this.inputs
        .filter((i) => i.checked && !i.hasAttribute('data-hard') && i.value)
        .map((i) => i.value.toLowerCase());

      /* Bez vyberu ukazeme nejnovejsi kavy (ty nesou stitek „Nové"). */
      if (!required.length && !soft.length) {
        const created = (card) => parseInt(card.dataset.created, 10) || 0;
        const flagged = (card) => (card.hasAttribute('data-new') ? 1 : 0);
        const newest = this.cards
          .slice()
          .sort((a, b) => flagged(b) - flagged(a) || created(b) - created(a))
          .slice(0, this.results);
        this.show(newest);
        if (this.reason) this.say(this.emptyText);
        return;
      }

      /* Kandidati = kavy splnujici tvrde podminky; radime podle chuti,
         pri rovnosti rozhoduje los. */
      const ranked = this.cards
        .map((card, index) => ({ card, lot: this.lottery[index], ok: this.passes(card, required) }))
        .filter((c) => c.ok)
        .map((c) => {
          const tags = this.tagsOf(c.card);
          c.score = soft.reduce((sum, value) => sum + (tags.includes(value) ? 1 : 0), 0);
          return c;
        })
        .sort((a, b) => b.score - a.score || a.lot - b.lot);

      this.show(ranked.slice(0, this.results).map((c) => c.card));

      if (!this.reason) return;
      if (!ranked.length) {
        this.say(this.noMatchText);
      } else if (!soft.length || ranked[0].score === soft.length) {
        this.say(this.fullMatchText);
      } else {
        this.say(this.partialText);
      }
    }
  }

  if (!customElements.get('tb-finder')) customElements.define('tb-finder', TbFinder);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-footer"]) return;
  try {
    
  /* Nastaveni cookies: Shopify lista se nacita asynchronne, takze na
     privacyBanner chvili cekame. Kdyz neprijde (lista vypnuta v adminu),
     tlacitko zustane skryte. */
  (() => {
    const wrap = document.querySelector('[data-tb-cookies]');
    if (!wrap) return;
    const button = wrap.querySelector('button');
    const ready = () => typeof window.privacyBanner?.showPreferences === 'function';

    button.addEventListener('click', () => {
      if (ready()) window.privacyBanner.showPreferences();
    });

    let tries = 0;
    const reveal = () => {
      if (ready()) { wrap.hidden = false; return; }
      if (++tries < 20) setTimeout(reveal, 500);
    };
    reveal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-gift-steps"] && !Shopify.designMode) return;
  try {
    
  /* Velikost v karte prepne cenu a variantu na tlacitku pod ni. */
  document.addEventListener('change', (event) => {
    const opt = event.target.closest && event.target.closest('[data-gsteps-opt]');
    if (!opt) return;
    const card = opt.closest('[data-gsteps-card]');
    const go = card && card.querySelector('[data-gsteps-go]');
    if (!go) return;
    go.dataset.giftPick = opt.value;
    const price = card.querySelector('[data-gsteps-price]');
    if (price) price.textContent = opt.dataset.price;
    const monthly = card.querySelector('[data-gsteps-monthly]');
    if (monthly) monthly.textContent = opt.dataset.monthly;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-hero-cards"] && !Shopify.designMode) return;
  try {
    
  class TbHeroCards extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.tb-hc__rail');
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;

      this.update = this.update.bind(this);
      this.prev?.addEventListener('click', () => this.go(-1));
      this.next?.addEventListener('click', () => this.go(1));
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.resize = new ResizeObserver(this.update);
      this.resize.observe(this.track);

      /* Editor: vybrany blok se posune do zaberu. */
      this.onSelect = (event) => {
        const item = event.target.closest?.('[data-item]');
        if (item && this.contains(item)) this.reveal(item);
      };
      document.addEventListener('shopify:block:select', this.onSelect);

      this.update();
    }

    disconnectedCallback() {
      this.resize?.disconnect();
      document.removeEventListener('shopify:block:select', this.onSelect);
    }

    pad() {
      return parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
    }

    /* Posun o tolik celych karet, kolik jich je videt – jako na Netflixu. */
    go(direction) {
      const first = this.track.querySelector('[data-item]');
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = first.offsetWidth + gap;
      const fits = Math.max(1, Math.floor((this.track.clientWidth - this.pad()) / step));
      this.track.scrollBy({ left: direction * fits * step, behavior: this.behavior() });
    }

    reveal(item) {
      this.track.scrollTo({ left: item.offsetLeft - this.pad(), behavior: this.behavior() });
    }

    behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const x = this.track.scrollLeft;
      const atStart = x <= 2;
      const atEnd = x >= max - 2;
      if (this.prev) this.prev.disabled = atStart;
      if (this.next) this.next.disabled = atEnd;
      this.rail.toggleAttribute('data-at-start', atStart);
      this.rail.toggleAttribute('data-at-end', atEnd);
    }
  }

  if (!customElements.get('tb-hero-cards')) customElements.define('tb-hero-cards', TbHeroCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-inquiry"] && !Shopify.designMode) return;
  try {
    
  /* Poptavka + novinky: pri zaskrtnuti nejdriv odesleme customer form
     (fetch, bez navigace), pak necháme poptavku odejit normalne. Selhani
     odberu poptavku nezastavi – ta je dulezitejsi. */
  document.querySelectorAll('.tb-inq__form').forEach((form) => {
    const optin = form.querySelector('[data-optin]');
    const card = form.closest('.tb-inq__card');
    const subscribe = card && card.querySelector('[data-optin-form]');
    if (!optin || !subscribe) return;

    let done = false;
    form.addEventListener('submit', (event) => {
      if (done || !optin.checked) return;
      const email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;

      event.preventDefault();
      subscribe.querySelector('input[name="contact[email]"]').value = email.value;

      const finish = () => { done = true; form.requestSubmit(); };
      fetch(subscribe.action, { method: 'POST', body: new FormData(subscribe), credentials: 'same-origin' })
        .then(finish, finish);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-marquee"] && !Shopify.designMode) return;
  try {
    
  // Bez doplnení by pás na širokém okne odjel a vpravo zbyla prázdná půlka,
  // protože dva běhy krátkého textu se do obrazovky nevejdou dvakrát.
  class TbMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tb-mq__track');
      this.master = this.track && this.track.querySelector('.tb-mq__run');
      if (!this.master) return;

      this.fill = this.fill.bind(this);
      this.fill();

      // Šířka okna i šířka textu se mohou změnit – při přepnutí na jiné
      // rozlišení i poté, co dorazí vlastní font.
      this.observer = new ResizeObserver(this.fill);
      this.observer.observe(this);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fill);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    fill() {
      const run = this.master.getBoundingClientRect().width;
      const view = this.getBoundingClientRect().width;
      if (!run || !view) return;

      // O jeden běh víc, než se vejde do okna: v okamžiku, kdy první běh
      // odjede za levou hranu, musí být zprava připravený další.
      const copies = Math.max(2, Math.ceil(view / run) + 1);
      if (copies === this.copies) return;
      this.copies = copies;

      const runs = this.track.querySelectorAll('.tb-mq__run');
      for (let i = runs.length - 1; i > 0; i--) runs[i].remove();

      const batch = document.createDocumentFragment();
      for (let i = 1; i < copies; i++) batch.appendChild(this.master.cloneNode(true));
      this.track.appendChild(batch);

      this.style.setProperty('--tb-mq-copies', copies);
    }
  }

  if (!customElements.get('tb-marquee')) customElements.define('tb-marquee', TbMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-product"] && !Shopify.designMode) return;
  try {
    
  class TbProductGallery extends HTMLElement {
    connectedCallback() {
      this.shots = [...this.querySelectorAll('[data-shot]')];
      this.thumbs = [...this.querySelectorAll('[data-pick]')];
      if (!this.shots.length) return;

      this.show(0);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.pick))));
    }

    show(index) {
      this.shots.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.thumbs.forEach((el, i) => {
        if (i === index) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('tb-product-gallery')) customElements.define('tb-product-gallery', TbProductGallery);

  class TbProduct extends HTMLElement {
    connectedCallback() {
      const root = this;
      this.root = root;
      const data = root.querySelector('[data-tb-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      if (!this.variants.length) return;

      this.idField = root.querySelector('[data-tb-variant-id]');
      this.qty = root.querySelector('[data-tb-qty]');
      this.price = root.querySelector('[data-tb-price]');
      this.was = root.querySelector('[data-tb-was]');
      this.perKg = root.querySelector('[data-tb-perkg]');
      this.unit = root.querySelector('[data-tb-unit]');
      this.total = root.querySelector('[data-tb-total]');
      this.cta = root.querySelector('.tb-product__cta');
      const stockText = root.querySelector('[data-tb-stock-text]');
      this.inStockLabel = root.dataset.inStock || (stockText ? stockText.textContent.trim() : '');
      this.soldOutLabel = root.dataset.soldOut || '';
      this.ctaLabel = this.cta ? this.cta.dataset.tbLabel || this.cta.textContent.trim() : '';
      if (this.cta) this.cta.dataset.tbLabel = this.ctaLabel;

      root.querySelectorAll('[data-tb-pick]').forEach((input) => {
        input.addEventListener('change', () => this.render());
      });

      root.querySelectorAll('[data-tb-step]').forEach((button) => {
        button.addEventListener('click', () => this.bump(Number(button.dataset.tbStep)));
      });

      if (this.qty) this.qty.addEventListener('change', () => this.render());

      // Mleti: odskrtnuto = select vypnuty, takze se vlastnost neodesle.
      const grindToggle = root.querySelector('[data-tb-grind-toggle]');
      const grindPick = root.querySelector('[data-tb-grind-pick]');
      const grindSelect = root.querySelector('[data-tb-grind-select]');
      if (grindToggle && grindPick && grindSelect) {
        const syncGrind = () => {
          grindPick.hidden = !grindToggle.checked;
          grindSelect.disabled = !grindToggle.checked;
        };
        grindToggle.addEventListener('change', syncGrind);
        syncGrind();
      }

      const taste = root.querySelector('[data-tb-taste]');
      if (taste) {
        const value = taste.querySelector('[data-tb-taste-value]');
        const syncTaste = () => {
          const picked = [...taste.querySelectorAll('[data-tb-taste-opt]:checked')].map((box) => box.value);
          value.value = picked.join(', ');
          value.disabled = picked.length === 0;
        };
        taste.addEventListener('change', syncTaste);
        syncTaste();
      }

      this.stick();
      this.subscription();
      this.render();
    }

    current() {
      const picked = this.root.querySelector('[data-tb-pick]:checked');
      const id = picked ? picked.value : this.idField && this.idField.value;
      return this.variants.find((v) => String(v.id) === String(id)) || this.variants[0];
    }

    bump(by) {
      if (!this.qty) return;
      const max = Number(this.qty.max) || 20;
      const next = Math.min(max, Math.max(1, (Number(this.qty.value) || 1) + by));
      this.qty.value = String(next);
      this.render();
    }

    render() {
      const v = this.current();
      if (!v) return;

      const max = this.qty ? Number(this.qty.max) || 20 : 1;
      let count = this.qty ? Number(this.qty.value) || 1 : 1;
      count = Math.min(max, Math.max(1, Math.round(count)));
      if (this.qty && String(count) !== this.qty.value) this.qty.value = String(count);

      if (this.idField) this.idField.value = String(v.id);
      if (this.price) this.price.textContent = v.price;
      if (this.perKg) this.perKg.textContent = v.perKg || '';
      if (this.unit) this.unit.textContent = v.unit;

      if (this.was) {
        this.was.textContent = v.was || '';
        this.was.hidden = !v.was;
      }

      const stock = this.root.querySelector('[data-tb-stock]');
      if (stock) {
        stock.classList.toggle('is-out', !v.available);
        const label = stock.querySelector('[data-tb-stock-text]');
        if (label) label.textContent = v.available ? this.inStockLabel : this.soldOutLabel;
      }

      const total = v.totals[count - 1] || v.price;
      if (this.total) this.total.textContent = total;
      /* Pozor na textContent: tlacitko vedle popisku nese i znacku fajfky,
         kterou Horizon ukazuje po pridani do kosiku. Prepsani celeho obsahu
         by ji smazalo, tak menime jen prvni textovy uzel. */
      if (this.cta && v.available) {
        const label = this.ctaLabel + ' – ' + total;
        const textNode = [...this.cta.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
        if (textNode) textNode.nodeValue = label;
        else this.cta.insertBefore(document.createTextNode(label), this.cta.firstChild);
      }

      this.root.querySelectorAll('[data-tb-step]').forEach((button) => {
        const step = Number(button.dataset.tbStep);
        button.disabled = step < 0 ? count <= 1 : count >= max;
      });

      if (this.restick) this.restick();
      if (this.syncPlan) this.syncPlan();

      // Adresa musi nest zvolenou variantu, jinak sdileny odkaz otevre jinou.
      if (v.url && window.history.replaceState) {
        try {
          window.history.replaceState({}, '', v.url);
        } catch (e) {
          /* jiny puvod (nahled, iframe) – adresa se proste neprepise */
        }
      }
    }

    /* Predplatne (Shopify Subscriptions). App embed vykresli volby na konec
       stranky a jeho skript je ma presunout do [data-tb-sub] – na nasi
       sablone to dela nespolehlive a pri zmene volby pada (hleda prvky
       Debutu). Presun, skryte pole selling_plan a cenu proto ridime tady;
       udalost change zastavime uz pri zachytavani, aby se k jeho handleru
       nedostala. */
    subscription() {
      const slot = this.root.querySelector('[data-tb-sub]');
      if (!slot) return;
      const form = slot.closest('form');

      const field = () => {
        const box = document.querySelector('.shopify_subscriptions_app_block_container');
        if (box && !slot.contains(box)) slot.appendChild(box);
        const stray = document.querySelector('input.selected-selling-plan-id');
        if (stray && form && !form.contains(stray)) form.appendChild(stray);
        let input = form && form.querySelector('input[name="selling_plan"]');
        if (form && !input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          form.appendChild(input);
        }
        return input;
      };

      this.syncPlan = () => {
        const input = field();
        const plan = slot.querySelector('input[data-radio-type="selling_plan"]:checked');
        const once = slot.querySelector('input[data-radio-type="one_time_purchase"]:checked');
        if (input) input.value = plan ? plan.dataset.sellingPlanId : '';
        const id = plan
          ? `subscriptions_money_with_currency_${plan.dataset.sellingPlanGroupId}_${plan.dataset.sellingPlanId}`
          : once ? `subscriptions_money_with_currency_one_time_purchase_${once.dataset.variantId}` : '';
        const data = id && slot.querySelector(`script[id="${id}"]`);
        if (data && this.price) {
          try {
            const price = JSON.parse(data.textContent).price;
            if (price) this.price.textContent = price;
          } catch (e) { /* bez ceny plati cena varianty */ }
        }
      };

      slot.addEventListener('change', (event) => {
        const radio = event.target;
        if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio') return;
        event.stopPropagation();
        const block = radio.closest('.shopify_subscriptions_app_block');
        if (!block) return;
        // radia aplikace nemaji name – vylucnost hlidame sami
        block.querySelectorAll('input[type="radio"]').forEach((other) => {
          if (other !== radio) other.checked = false;
        });
        if (radio.dataset.radioType === 'selling_plan') {
          const group = block.querySelector(`input[id="${radio.dataset.sellingPlanGroupId}"]`);
          if (group) group.checked = true;
        } else if (radio.dataset.radioType === 'selling_plan_group') {
          const first = radio
            .closest('.shopify_subscriptions_app_block_label')
            ?.querySelector('.shopify_subscriptions_app_block_label_children input[type="radio"]');
          if (first) first.checked = true;
        }
        this.syncPlan();
      }, true);

      this.syncPlan();
      document.addEventListener('DOMContentLoaded', this.syncPlan);
      window.addEventListener('load', this.syncPlan);
    }

    stick() {
      const bar = this.root.querySelector('[data-tb-sticky]');
      const anchor = this.cta;
      if (!bar || !anchor) return;

      // Zamerne ne IntersectionObserver: ta se neozve, kdyz tlacitko preskoci
      // z „nad obrazovkou" rovnou „pod ni" (skok na kotvu). Scroll s rAF je
      // stejne levny a stav sedi vzdycky.
      const mobile = window.matchMedia('(max-width: 749px)');
      let queued = false;
      const update = () => {
        queued = false;
        if (anchor.disabled) {
          bar.hidden = true;
          return;
        }
        const r = anchor.getBoundingClientRect();
        if (mobile.matches) {
          // Telefon: cena a tlacitko jsou az ~1 200 px pod hranou, takze
          // lista je videt hned od nacteni – schova se jen, kdyz je hlavni
          // tlacitko na obrazovce aspon ze ctvrtiny.
          const seen = Math.max(0, Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0));
          bar.hidden = r.height > 0 && seen / r.height >= 0.25;
        } else {
          // Desktop: lista az kdyz hlavni tlacitko vyjelo nad horni hranu.
          bar.hidden = r.bottom > 0;
        }
      };
      const onScroll = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      };
      this.restick = onScroll;

      // capture: na desktopu roluje .page-wrapper, ne okno, a jeho scroll
      // k oknu neprobubla
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll, { passive: true });
      mobile.addEventListener('change', onScroll);
      // vyprodana varianta tlacitko vypne – lista pak nema co nabizet
      new MutationObserver(onScroll).observe(anchor, { attributes: true, attributeFilter: ['disabled'] });
      update();
    }
  }

  if (!customElements.get('tb-product')) customElements.define('tb-product', TbProduct);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-recommendations"] && !Shopify.designMode) return;
  try {
    
  class TbRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.performed === 'true' || !this.dataset.productId) return;
      const url = `${this.dataset.url}&product_id=${this.dataset.productId}&section_id=${this.dataset.sectionId}`;

      fetch(url)
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((html) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('tb-recommendations');
          const grid = fresh && fresh.querySelector('.tb-reco__grid');
          if (!grid || !grid.children.length) { this.hidden = true; return; }
          this.querySelector('.tb-reco__grid').replaceWith(grid);
        })
        .catch(() => { this.hidden = true; });
    }
  }

  if (!customElements.get('tb-recommendations')) customElements.define('tb-recommendations', TbRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-shop"] && !Shopify.designMode) return;
  try {
    
  class TbShopFilter extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('.tb-shop__card'));
      this.none = this.querySelector('[data-none]');
      if (!this.cards.length) return;

      this.addEventListener('change', (event) => {
        if (event.target.matches('input[name="tb-shop-filter"]')) this.apply(event.target.value);
      });
    }

    /* Prazdna hodnota je „vse“. Ukazeme prvnich `limit` shod;
       filtr nikdy neskryje vsechno bez vysvetleni. */
    apply(tag) {
      const limit = parseInt(this.dataset.limit, 10) || Infinity;
      let shown = 0;

      this.cards.forEach((card) => {
        const match = !tag || (card.dataset.tags || '').split(/\s+/).includes(tag);
        const visible = match && shown < limit;
        card.hidden = !visible;
        if (visible) shown += 1;
      });

      if (this.none) this.none.hidden = shown > 0;
    }
  }

  if (!customElements.get('tb-shop-filter')) customElements.define('tb-shop-filter', TbShopFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-visit"] && !Shopify.designMode) return;
  try {
    
  /* Tyden otviraci doby: zvyrazni dnesek a napise, jestli je ted otevreno.
     Cas vzdy v Praze, at navstevnik z jine zony nevidi stav podle svych hodin. */
  if (!customElements.get('tb-week')) {
    customElements.define('tb-week', class extends HTMLElement {
      connectedCallback() {
        this.days = Array.from(this.querySelectorAll('.tb-week__day'));
        this.status = this.querySelector('[data-status]');
        if (this.days.length !== 7) return;
        this.update();
        this.timer = setInterval(() => this.update(), 60000);
      }

      disconnectedCallback() { clearInterval(this.timer); }

      now() {
        const parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Prague', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false,
        }).formatToParts(new Date());
        const get = (type) => parts.find((p) => p.type === type)?.value || '';
        const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday'));
        return { day, minutes: (Number(get('hour')) % 24) * 60 + Number(get('minute')) };
      }

      /* „10–17", „10:00–17:30" → minuty od pulnoci */
      range(text) {
        const m = (text || '').match(/(\d{1,2})(?::(\d{2}))?\s*[–-]\s*(\d{1,2})(?::(\d{2}))?/);
        if (!m) return null;
        return { from: m[1] * 60 + Number(m[2] || 0), to: m[3] * 60 + Number(m[4] || 0) };
      }

      clock(minutes) {
        return Math.floor(minutes / 60) + ':' + String(minutes % 60).padStart(2, '0');
      }

      update() {
        const { day, minutes } = this.now();
        if (day < 0) return;

        this.days.forEach((li, i) => {
          const today = i === day;
          li.classList.toggle('is-today', today);
          if (today) li.setAttribute('aria-current', 'date');
          else li.removeAttribute('aria-current');
          const hours = li.querySelector('.tb-week__hours');
          if (li.classList.contains('is-closed')) {
            hours.innerHTML = today
              ? 'dnes<span class="visually-hidden"> zavřeno</span>'
              : '<span aria-hidden="true">—</span><span class="visually-hidden">zavřeno</span>';
          }
        });

        if (!this.status) return;
        const todayRange = this.range(this.days[day].dataset.hours);
        let text = '';
        let open = false;
        if (todayRange && minutes >= todayRange.from && minutes < todayRange.to) {
          open = true;
          text = 'Teď otevřeno · do ' + this.clock(todayRange.to);
        } else if (todayRange && minutes < todayRange.from) {
          text = 'Dnes otevíráme v ' + this.clock(todayRange.from);
        } else {
          const when = ['v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu', 'v neděli'];
          for (let step = 1; step <= 7; step += 1) {
            const next = (day + step) % 7;
            const r = this.range(this.days[next].dataset.hours);
            if (r) {
              text = 'Teď zavřeno · otevíráme ' + (step === 1 ? 'zítra' : when[next]) + ' v ' + this.clock(r.from);
              break;
            }
          }
        }
        this.status.textContent = text;
        this.status.dataset.open = open ? 'true' : 'false';
        this.status.hidden = !text;
      }
    });
  }

  /* Mapa se nacte po kliknuti, nebo sama po souhlasu s marketingovymi
     cookies (Shopify Customer Privacy API). */
  if (!customElements.get('tb-map')) {
    customElements.define('tb-map', class extends HTMLElement {
      connectedCallback() {
        this.querySelector('[data-tb-map-load]')?.addEventListener('click', () => this.load(true));
        const check = () => {
          const privacy = window.Shopify?.customerPrivacy;
          if (privacy?.marketingAllowed?.()) this.load(false);
        };
        document.addEventListener('visitorConsentCollected', check);
        if (window.Shopify?.customerPrivacy) check();
        else window.addEventListener('load', check, { once: true });
      }

      load(focus) {
        if (this.querySelector('iframe')) return;
        const frame = document.createElement('iframe');
        frame.className = 'tb-visit__map';
        frame.src = this.dataset.src;
        frame.title = this.dataset.title || '';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'no-referrer-when-downgrade';
        this.replaceChildren(frame);
        if (focus) frame.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
